// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable, action, computed } from 'mobx';
import UiState from 'logic/Izenda.UiState';
import { isNil } from 'lodash/fp';
import tracker from 'share/tracking/Izenda.Tracker';
import ImportHistory from 'logic/models/Izenda.ImportHistory';
import importFetcher from 'fetchers/Izenda.ImportFetcher';

@tracker
export default class ImportHistoryStore {
  @observable model: ImportHistory = null;
  @observable response: any = {};

  @computed
  get tenantId() {
    return UiState.getTenantId();
  }

  constructor() {
    this.model = new ImportHistory();
  }

  /**
   * Load data
   */
  @action
  loadData(): void {
    const data = this.model.getRequestPage(this.tenantId);

    return importFetcher.loadImportHistories(data).then(response => {
      this.response = response;
      this.populate(this.response);

      return Promise.resolve(response);
    });
  }

  /**
   * Delete history 1 file or multiples
   * @param {Object} historyFile
   * @returns {Promise}
   */
  @action
  deleteHistories(historyFile: any): Promise {
    let historiesToDelete = [];
    this.model.deletedId = '';

    if (isNil(historyFile)) {
      historiesToDelete = this.model.getSelectedIds(); // If not put in parameter, delete selected histories
    } else {
      historiesToDelete.push(historyFile.id);
      this.model.deletedId = historyFile.id;
    }

    return importFetcher.deleteHistories(historiesToDelete);
  }

  /**
   * Populate model
   * @param {Object} response
   */
  @action
  populate(response: any): void {
    this.model.populate(response);
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ImportHistoryStore.js